import React, { Fragment, lazy, memo, Suspense, useCallback, useEffect, useState, } from 'react';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { ComponentHolderStyled, WrapperStyled } from './styled';
const ShowMoreText = lazy(() => import('react-show-more-text'));
function RenderLoader() {
    // eslint-disable-next-line react/jsx-fragments, react/jsx-no-useless-fragment
    return React.createElement(Fragment, null);
}
function ShowMoreComponent(props) {
    const { labelShowLess, labelShowMore, maxLinesCount = 3, children, wrapper, buttonColor = colorCoreBlack900Base, textColor = colorCoreBlack900Base, bottomIndent, keepNewLines = true, setShowMoreReady, setIsExpanded, isExpanded, } = props;
    const [readyToShow, setReadyToShow] = useState(false);
    const { width } = useWindowSize();
    const isShowMoreVisible = Boolean(labelShowLess && labelShowMore);
    const showMoreClickHandle = useCallback(() => {
        if (setIsExpanded) {
            setIsExpanded(!isExpanded);
        }
    }, [isExpanded, setIsExpanded]);
    useEffect(() => {
        if (children) {
            document?.fonts?.ready.then(() => {
                setReadyToShow(true);
            });
        }
    }, [children, width]);
    useEffect(() => {
        if (setShowMoreReady && readyToShow) {
            setShowMoreReady(readyToShow);
        }
    }, [readyToShow, setShowMoreReady]);
    if (!children) {
        return null;
    }
    return (React.createElement(ComponentHolderStyled, { wrapper: wrapper },
        React.createElement(Suspense, { fallback: React.createElement(RenderLoader, null) },
            React.createElement(WrapperStyled, { isButtonVisible: isShowMoreVisible, bottomIndent: bottomIndent, buttonColor: buttonColor, textColor: textColor }, readyToShow && (React.createElement(ShowMoreText, { lines: maxLinesCount, more: labelShowMore, less: labelShowLess, onClick: showMoreClickHandle, 
                // Warning! Don't remove this extra fix (it prevented UI issue)
                truncatedEndingComponent: React.createElement(React.Fragment, null,
                    React.createElement("span", null, "... "),
                    "\u00A0"), keepNewLines: keepNewLines }, children))))));
}
export const ShowMore = memo(ShowMoreComponent);
ShowMore.displayName = 'ShowMore_Component';
